<template>
  <div id="app" class="fluid-container">
    <header class="app-header"><img src="./assets/images/logo.svg" /></header>
    <Sidebar>
      <Burger class="burger-close"></Burger>
      <ul class="sidebar-panel-nav">
        <li @click.prevent="togglePanel">
          <router-link to="/">All Hatches</router-link>
        </li>
        <li @click.prevent="togglePanel">
          <router-link to="/port">Port</router-link>
        </li>
        <li @click.prevent="togglePanel">
          <router-link to="/starboard">Starboard</router-link>
        </li>
        <li @click.prevent="togglePanel">
          <router-link to="/hatch-1">Hatch 1</router-link>
        </li>
        <li @click.prevent="togglePanel">
          <router-link to="/hatch-2">Hatch 2</router-link>
        </li>
        <li @click.prevent="togglePanel">
          <router-link to="/hatch-3">Hatch 3</router-link>
        </li>
        <li @click.prevent="togglePanel">
          <router-link to="/hatch-4">Hatch 4</router-link>
        </li>
      </ul>
    </Sidebar>
    <div class="row" id="lower-nav">
      <Burger></Burger>
      <h3 class="current-hatch">{{ currentHatch }}</h3>
    </div>
    <router-view />
    <footer class="footer">
      <div class="hatch-bgd"></div>
    </footer>
  </div>
</template>
<script>
import { store, mutations } from '@/store';
import Burger from './components/Menu/Burger.vue';
import Sidebar from './components/Menu/Sidebar.vue';

export default {
  name: 'app',
  components: {
    Burger,
    Sidebar,
  },
  computed: {
    currentHatch() {
      return store.currentHatch;
    },
  },
  methods: {
    togglePanel() {
      mutations.toggleNav();
      mutations.setCurrentHatch(document.title);
    },
  },
  watch: {
    $route(to) {
      document.title = to.meta.title;
    },
  },
  mounted() {
    document.title = 'All Hatches';
    mutations.setCurrentHatch(document.title);
  },
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap";
@import "@/styles/_variables";
@import "@/styles/main";
@import "@/styles/_buttons";
</style>
